import axios from 'axios';
import { getToken } from 'utils/crypto';

const INVITE_FORM_PATH = '/register-form';

/**
 * Mint a fresh signed URL for a file via POST /api/files/download-url
 * (or /api/files/invite/download-url when an invite token is present — see below).
 * Accepts a StoredFile ({key, originalName}) or a parent doc ({file: {key, ...}}).
 * Returns the fresh URL, or null if the file has no key.
 */
export const getFreshFileUrl = async (file, opts = {}) => {
    const resolved = file?.file?.key ? file.file : file;
    if (!resolved?.key) return resolved?.url || null;


    // The public intake form has no session, so it authenticates with the invite token.
    // Prefer an explicit opts.inviteToken; otherwise, on /register-form, read it from the
    // query string (window.location — this is not a component, so no router hooks).
    const inviteToken =
        opts.inviteToken ||
        (window.location.pathname === INVITE_FORM_PATH ? new URLSearchParams(window.location.search).get('token') : null);
    const endpoint = inviteToken ? '/files/invite/download-url' : '/files/download-url';
    const headers = inviteToken ? { 'invite-token': inviteToken } : { 'access-token': getToken() };

    try {
        const { data } = await axios.post(
            endpoint,
            {
                key: resolved.key,
                originalName: resolved.originalName || '',
                disposition: opts.disposition || 'inline',
            },
            { headers },
        );
        return data.url;
    } catch {
        return resolved.url || null;
    }
};
